export default __webpack_public_path__ + "static/media/nft-4@2x.b55222a9.png";